import React, { useEffect } from "react";
import { useSwipeable } from 'react-swipeable';
import { ArrowBackIosOutlined as ArrowBackIosOutlinedIcon } from '@mui/icons-material';
import { ArrowForwardIosOutlined as ArrowForwardIosOutlinedIcon } from '@mui/icons-material';
import PropTypes from 'prop-types';
import {
    CarouselContainer,
    CarouselSlot,
    PREV,
    NEXT,
    SlideButton,
    CarouselContainerWithArrow,
    DotsContainer,
    Dot
} from "./components";

const getOrder = ({ index, pos, numItems }) => {
    return index - pos < 0 ? numItems - Math.abs(index - pos) : index - pos;
};
const initialState = { pos: 0, sliding: false, dir: NEXT };

export default function Carousel(props) {

    const [state, dispatch] = React.useReducer(reducer, initialState);
    const timeoutRef = React.useRef(null);
    const isActionButtonVisible = props.numItems > props.cardPerScreen

    function resetTimeout() {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
    }

    useEffect(() => {
        if (props.isAutoCarousel) {
            resetTimeout();
            timeoutRef.current = setTimeout(() => {
                slide(NEXT);
                props.changeCurrentIndex(NEXT);
            }, 6000);

            return () => {
                resetTimeout();
            };
        }
    }, [props.currentIndex]);

    const slide = dir => {
        dispatch({ type: dir, numItems: props.numItems, cardPerScreen: props.cardPerScreen > 0 ? props.cardPerScreen : 1 });
        setTimeout(() => {
            dispatch({ type: "stopSliding" });
        }, 50);
    };

    const handlers = useSwipeable({
        onSwipedLeft: () => slide(NEXT),
        onSwipedRight: () => slide(PREV),
        preventDefaultTouchmoveEvent: true,
        trackMouse: true,
    });

    return (
      <React.Fragment>
        {props.showArrow ? (
          <React.Fragment>
            <div className="d-flex justify-content-center align-items-center px-0">
              {isActionButtonVisible && <SlideButton
                onClick={() => {
                  slide(PREV);
                  props.changeCurrentIndex(PREV);
                }}
                $float="left"
                $left={15}
                marginTop={props.topPosition}
                width={props.iconWidth}
                height={props.iconWidth}
              >
                <ArrowBackIosOutlinedIcon htmlColor="grey" className={props.carouselArrow} />
              </SlideButton>}
              <div {...handlers} style={{ transform: 'translateX(0%)', position: 'relative' }} className={props.swipeAble}>
                <CarouselContainerWithArrow dir={state.dir} $sliding={state.sliding}>
                  {props.items.map((item, index) => (
                    <CarouselSlot key={index} order={getOrder({ index: index, pos: state.pos, numItems: props.numItems })}>
                      {item}
                    </CarouselSlot>
                  ))}
                </CarouselContainerWithArrow>
              </div>
              {isActionButtonVisible && <SlideButton
                onClick={() => {
                  slide(NEXT);
                  props.changeCurrentIndex(NEXT);
                }}
                $float="right"
                $right={0}
                marginTop={props.topPosition}
                width={props.iconWidth}
                height={props.iconWidth}
              >
                <ArrowForwardIosOutlinedIcon htmlColor="grey" className={props.carouselArrow} />
              </SlideButton>}
            </div>
            {props.isDOtContainer && isActionButtonVisible && <DotsContainer>
              {props.cardsForDots.map((_, index) => (
                <Dot key={index} $active={index === props.currentIndex} />
              ))}
            </DotsContainer>}
          </React.Fragment>
        ) : (
          <div {...handlers}>
            <CarouselContainer dir={state.dir} $sliding={state.sliding}>
              {props.items.map((item, index) => (
                <CarouselSlot key={index} order={getOrder({ index: index, pos: state.pos, numItems: props.numItems })} className="carouselItem carrier-img">
                  {item}
                </CarouselSlot>
              ))}
            </CarouselContainer>
          </div>
        )}
      </React.Fragment>
    );
};

function reducer(state, { type, numItems, cardPerScreen }) {
    switch (type) {
        case "reset":
        return initialState;
      case PREV:
        const numberOfItemsPrev = numItems % cardPerScreen === 0 ? 0 : 1;
        const statePosPrev = state.pos % cardPerScreen === 0 ? state.pos : state.pos - (state.pos % cardPerScreen);
        return {
          ...state,
          dir: PREV,
          sliding: true,
          pos: statePosPrev === 0 ? numItems - cardPerScreen + numberOfItemsPrev : state.pos - cardPerScreen,
        };
      case NEXT:
        const numberOfItemsNext = numItems % cardPerScreen === 0 ? numItems : numItems + 1; 
        const statePosNext = state.pos % cardPerScreen === 0 ? state.pos : state.pos - (state.pos % cardPerScreen);
        return {
          ...state,
          dir: NEXT,
          sliding: true,
          pos: statePosNext === numberOfItemsNext - cardPerScreen ? 0 : state.pos + cardPerScreen,
        };
        case "stopSliding":
        return { ...state, sliding: false };
      default:
        return state;
    }
}

Carousel.propTypes = {
    items: PropTypes.array.isRequired,
};
